import React, { Component } from 'react';
import ReportingGridRow from './ReportingGridRow';

class ReportingGrid extends Component {
  render() {
    const { data, onClick } = this.props;
    return (
      <div className="execution-reporting-grid">
        {data.map(item => <ReportingGridRow key={item.id} data={item} onClick={onClick} />)}
      </div>
    );
  }
}

export default ReportingGrid;



// WEBPACK FOOTER //
// ./src/containers/Reporting/ReportingGrid.jsx